import styled from 'styled-components';
import {
  color,
  container,
  fontFamily,
  fontSize,
  fontWeight,
  screen,
  spacing
} from 'theme';

export const StyledPostHeader = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: ${spacing('xl')};
  gap: 0;
  max-width: ${container('lg')};

  @media (max-width: ${screen('lg')}) {
    padding-bottom: 24px;
  }
`;

export const StyledHeaderContent = styled.div`
  display: contents;
  align-items: center;
  justify-content: center;
`;

export const StyledHeaderTitle = styled.h1`
  font-family: ${fontFamily('serif')};
  font-weight: ${fontWeight('black')};
  font-size: ${fontSize('xl5')};
  line-height: 1.17;

  grid-area: title;
  color: #2d2d3a;
  margin: ${spacing('md')} 0;
  line-height: 1.15;
  text-align: center;

  @media (max-width: ${screen('lg')}) {
    margin: 24px 0 16px 0;
    font-size: 2rem;
    line-height: 1.2;
  }
`;

export const StyledHeaderThumb = styled.div`
  grid-area: thumb;
  display: flex;
  align-items: start;
  justify-content: center;
  overflow: hidden;
  min-block-size: 0;
  width: 100%;

  img {
    width: 100%;
    height: auto;
    object-fit: cover;
    mask-image: url('/images/common/irregular-box-white.svg');
    mask-size: 100% 100%;
    mask-repeat: no-repeat;
    mask-position: center;
    -webkit-mask-image: url('/images/common/irregular-box-white.svg');
    -webkit-mask-size: 100% 100%;
    -webkit-mask-repeat: no-repeat;
    -webkit-mask-position: center;
  }

  @media (max-width: ${screen('lg')}) {
    justify-self: center;
    margin-top: 24px;
  }
`;

export const StyledHeaderAuthorName = styled.a`
  color: ${color('emerald_600')};
  font-weight: ${fontWeight('semiBold')};
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

export const StyledHeaderMetaTable = styled.div`
  grid-area: meta;
  display: grid;
  grid-template-areas: 'published';
  grid-template-columns: max-content;
  column-gap: 24px;
  row-gap: 16px;
  margin-top: 16px;
  align-items: center;
`;

export const MetaEntry = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
`;

export const MetaAvatar = styled.img`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  flex-shrink: 0;
  object-fit: cover;
`;

export const MetaText = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
`;

export const MetaTitle = styled.span`
  font-size: 0.85rem;
  font-weight: ${fontWeight('medium')};
  color: #6b6b7b;
  margin-bottom: 2px;
  white-space: nowrap;
`;

export const MetaValue = styled.span`
  font-size: 0.95rem;
  font-weight: ${fontWeight('semiBold')};
  color: #2d2d3a;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const AuthorEntry = styled(MetaEntry)`
  grid-area: author;
`;
export const PublishedEntry = styled(MetaEntry)`
  grid-area: published;
`;
export const UpdatedEntry = styled(MetaEntry)`
  grid-area: updated;
`;
export const ReadTimeEntry = styled(MetaEntry)`
  grid-area: readtime;
`;

export const StyledTagsAndShare = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 16px;
  margin-top: 16px;
`;
export const StyledHeaderTags = styled.div`
  grid-area: tags;
  justify-self: center;
  margin-bottom: 8px;
`;
export const ShareButton = styled.div`
  max-width: ${container('md')};
`;
